<template>
  <div>
    <el-tooltip :content="$t('accountProfileDetails.traitChange.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true" class="zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-pencil-outline"/></base-button>

    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountProfileDetails.traitChange.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small class="text-wrap">{{ $t('accountProfileDetails.traitChange.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.traitChange.form.trait')
              }}</label>
            <div class="col-md-9">
              <base-input
                :error="getError('trait')">
                <el-select
                  name="trait"
                  data-vv-as="'trait'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="formDetails.trait"
                :placeholder="$t('accountProfileDetails.traitChange.form.traitPlaceholder')">
                  <el-option
                    v-for="option in availableAccountTraits"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountProfileDetails.traitChange.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'changeAccountTraitBtn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        trait: '',
      },
      modelValidations: {
        required: {
          required: true
        },
      }
    }
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account.updating,
      error: state => state.account.error,
      data: state => state.account.data,
      availableAccountTraits: state => state.account.availableAccountTraits,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['UpdateAccountTrait', 'LoadAccountAuditLogs']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.UpdateAccountTrait({id: this.accountId, data: this.formDetails}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.LoadAccountAuditLogs({id: this.accountId, query: {id: "", filter: "", action_result:""}})
          this.$notify({
            type: 'success',
            message: this.$t('accountProfileDetails.traitChange.createdNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        trait: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  },
  mounted() {
  },
}
</script>
